import { EmployeesHelper } from "@/common/entities/helpers";
import { ListResult, POPULATION_TYPE } from "@/common/models";
import { SharedState } from "@/common/state";
import { correctTier12XY } from "@/gql/cords";
import { formatInput, gql2 } from "@/gql/lib";
import {
  ActionEnum,
  CoordinateInputTier1Tier2,
  CountOrderByEnum,
  Direction,
  getEmailAddressFromExtendedData,
  getFolderOwnerOrSite,
  GroupByEnum,
  QueryTier1countArgs,
  targetAxis,
} from "@/gql/types";

export const get_entities = gql2<
  {
    type: POPULATION_TYPE;
    cursor: string;
    coordinate: CoordinateInputTier1Tier2;
    target_axis?: targetAxis;
  },
  ListResult<any>
>(
  "entities.get",
  ({ coordinate, type, cursor, target_axis = targetAxis.X }) => {
    const q: QueryTier1countArgs = {
      params: correctTier12XY({
        coordinate,
        cursor,
        action: ActionEnum.List,
        targetAxis: target_axis,
        direction: Direction.Descend,
        orderBy: CountOrderByEnum.Count,
      }),
    };
    return {
      query: `{
        #EXPORT
        entities: tier2count(params:${formatInput(q.params)}){
            cursor
            count
            files
            startDate
            endDate
            entities{
                id
                extendedData
                name
                email
                department
                externalId
                path
                ownerOrSite
                sourceApplication
                labels{
                  labelCategory
                  name
                  id
                }
            }
          }
          #EXPORT_END
        }`,
      mapper: (res) => {
        const { entities } = res;
        let cursor = "";
        if (entities.length > 0) {
          cursor = entities[0].cursor;
        }
        return {
          cursor,
          objects: entities.map((d: any) => {
            const {
              name,
              id,
              sourceApplication,
              extendedData,
              labels = [],
            } = d.entities[0];
            // const url = getFolderUrl(extendedData);
            return {
              id,
              name,
              startDate: d.startDate,
              endDate: d.endDate,
              department:
                type === POPULATION_TYPE.EMPLOYEE
                  ? EmployeesHelper.get_department_from_labels(labels)
                  : "",
              files: d.files,
              count: d.count,
              type,
              email: d.entities[0].email,
              externalId: getEmailAddressFromExtendedData(d.entities[0]),
              source: sourceApplication,
              url: d.entities[0].path, //url,
              ownerOrSite: d.entities[0].ownerOrSite, //getFolderOwnerOrSite(sourceApplication, url),
            };
          }),
        };
      },
    };
  }
);

const getFolderUrl = (extendedData: string): string => {
  let location = "---";
  if (extendedData) {
    try {
      const parsed: any = JSON.parse(extendedData);
      location = parsed.url;
    } catch (e) {
      console.log("error in parsing extended data :", e);
    }
  }
  return location;
};
